import { cloneDeep } from 'lodash';
const SET_DECLINE_BOX_BOOK = 'SET_DECLINE_BOX_BOOK';
const CLEAR_DECLINE_BOX_BOOK = 'CLEAR_DECLINE_BOX_BOOK';
import { setComputedCart } from './computed_cart';
import { setFeedback, delayedClearFeedback } from './feedback';
import { setCustomer } from './customer';
import { closeModal, openMiniCartModal }  from './active_modal';
import { addToCartO, MAX_CART_ITEM } from '../shared/cart';
import request from 'superagent';

const initialState = null;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_DECLINE_BOX_BOOK:
			return action.payload; //FEATURED_SELECTION_VIEW_DECLINE;
		case CLEAR_DECLINE_BOX_BOOK:
			return null;
		default:
			return state;
	}
}

export function setDeclineBook(bookTitle, quantity){
	return {
		type: SET_DECLINE_BOX_BOOK,
		payload: { product: bookTitle, quantity: quantity }
	}
}

export function clearDeclineBook(){
	return { type: CLEAR_DECLINE_BOX_BOOK };
}

export function declineBox(){
	return (dispatch, getState) => {
		dispatch(closeModal());
		request
      .put('/svc/customer/cycle/decline_box')
      .set('Accept', 'application/json')
      .end((err, res) => {
      	if (err || ![200,201,202].includes(res.statusCode) ){
          return dispatch([
            setFeedback('Could not decline box. Please try again.'),
            delayedClearFeedback()
          ]);
        }
        return dispatch([
        	setCustomer(res.body),
        	setFeedback('You have skipped this month\'s box. '),
          delayedClearFeedback()
        ]);
    });
	};
}

export function boxActionAccept() {
  return (dispatch, getState) => {
  	let oCart = getState().customer.cart.filter(x=>x);
  	if(oCart.length + getState().featured.length === MAX_CART_ITEM + 1)
  		return dispatch([
  			setFeedback('There are too many books in your box to accept the Featured Selections. Please remove 1.'),
        delayedClearFeedback()
      ]);
  	else if(oCart.length + getState().featured.length === MAX_CART_ITEM + 2)
  		return dispatch([
  			setFeedback('There are too many books in your box to accept the Featured Selections. Please remove 2.'),
        delayedClearFeedback()
      ]);
  	//add books preemtively
    let oCustomer            = getState().customer;
    getState().featured.forEach( fs => {
      oCustomer.cart           = addToCartO(fs, 1,  oCustomer.cart, getState().featured, getState().store.bundle_pricing);
    });
    dispatch([
      openMiniCartModal(),
      setCustomer( oCustomer ),
      setComputedCart( oCustomer, getState().computedCart, [])
    ]);

    request
      .put('/svc/customer/cycle/accept_box' )
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.statusCode !== 200 ){
        	if(res && res.body ){
            dispatch([
              setCustomer(res.body),
              setComputedCart( res.body, getState().computedCart, [])
            ]);
          }
          return dispatch([
            setFeedback("Could not accept this cycle's box. Please check your payment methods in the account page."),
            delayedClearFeedback()
          ]);
        }
        let reading = getState().store.tla === "DVD" ? "viewing" : "reading";
        return dispatch([
          setCustomer(res.body),
          setComputedCart( res.body, getState().computedCart, []),
          setFeedback('Thank you for your purchase of the Featured Selections. Happy ' + reading + '!'),
          delayedClearFeedback()
        ]);
      });
  }
}


// WEBPACK FOOTER //
// ./src/modules/decline_box_book.js